"use client"

import { useEffect, useRef, useState } from "react"
import "./ServicesSection.css"
import OmarImg from "../assets/images/Omar.png"
import AntaresImg from "../assets/images/Antares.png"
import IrisImg from "../assets/images/Iris.png"
import BCANImg from "../assets/images/BCAN.png"
import TarifasImg from "../assets/images/Tarifas.png"
import Venga_le_prestoImg from "../assets/images/Venga_le_presto.png"
import ArcosImg from "../assets/images/Arcos.png"
import GestorImg from "../assets/images/Gestor.png"

const sampleServices = [
  {
    image: OmarImg,
    title: "OMAR",
    description: `Es una aplicación móvil que permite tener control, hacer seguimiento y obtener información sobre el registro de gastos de viajes de manera oportuna, 
    eficaz y verídica en línea. Facilita el control de registros de gastos y el seguimiento de la información en tiempo real, minimizando los procesos manuales.`,
  },
  {
    image: AntaresImg,
    title: "ANTARES",
    description: `Sistema comercial para empresas del sector eléctrico. Se logró implementar un sistema de cálculo tarifario 100 % confiable y auditable, 
    adecuado para los organismos de control y las empresas de servicios públicos.`,
  },
  {
    image: IrisImg,
    title: "IRIS",
    description: `Es una solución que permite a las empresas coordinar las actividades de transporte de sus colaboradores para cumplir con las programaciones 
    de trabajo, brindando trazabilidad en la operación mediante evidencias y geolocalización.`,
  },
  {
    image: BCANImg,
    title: "BCAN",
    description: `Realiza el registro de ventas, recaudos, financiaciones y refinanciaciones de cualquier producto o servicio TAT, 
    llevando el control de sus movimientos en tiempo real.`,
  },
  {
    image: TarifasImg,
    title: "TARIFAS",
    description: `Sistema de información que cuenta con un módulo flexible para calcular los costos y las tarifas aplicables a las diferentes 
    modalidades de prestación de servicios públicos, de acuerdo con la regulación vigente.`,
  },
  {
    image: Venga_le_prestoImg,
    title: "VENGA LE PRESTO",
    description: `A través de esta tecnología aplicada a las finanzas, es posible gestionar de manera transparente y ágil un servicio financiero, como préstamos 
    virtuales con validación tecnológica basada en machine learning, inteligencia artificial y big data.`,
  },
  {
    image: GestorImg,
    title: "GESTOR",
    description: `Innovadora aplicación móvil diseñada para empresas de servicios públicos, que funciona tanto en línea como fuera de línea. Permite realizar facturación 
    en sitio y gestionar fácilmente procesos en terreno, como el levantamiento de actas normativas y regulatorias, suspensión, reconexión, cobro persuasivo, entre otros. Además, 
    cuenta con capacidad de impresión inmediata, lo que agiliza las operaciones y mejora la atención al usuario final.`,
  },
  {
    image: ArcosImg,
    title: "ARCOS",
    description: `Esta aplicación es una herramienta intuitiva y versátil, diseñada para crear, personalizar y organizar encuestas y formularios de manera rápida y eficiente. 
    Es ideal para negocios, educadores, investigadores o cualquier usuario que necesite recopilar, analizar y organizar información de forma estructurada.`,
  },
]

const ServicesSection = () => {
  const [isVisible, setIsVisible] = useState(false)
  const sectionRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        }
      },
      { threshold: 0.1 },
    )

    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <section ref={sectionRef} id="services" className={`services-section ${isVisible ? "visible" : ""}`}>
      {/* Partículas flotantes de fondo */}
      <div className="floating-particles">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`,
            }}
          />
        ))}
      </div>

      {/* Efectos de fondo animados */}
      <div className="background-effects">
        <div className="bg-circle bg-circle-1" />
        <div className="bg-circle bg-circle-2" />
      </div>

      {/* Título principal */}
      <div className="section-header">
        <div className="section-badge">
          <span>🎖️ Proyectos</span>
        </div>

        <h2 className="section-title">
          <span className="title-main">NUESTROS PROYECTOS</span>
        </h2>

        <p className="section-description">Estos son algunos de nuestros principales proyectos realizados.</p>
      </div>

      {/* Grid de proyectos */}
      <div className="projects-container">
        <div className="projects-grid">
          {sampleServices.map((service, index) => (
            <div
              key={index}
              className="project-card"
              style={{
                transitionDelay: `${600 + index * 100}ms`,
              }}
            >
              <div className="flip-card">
                <div className="flip-card-inner">
                  {/* Frente - Solo imagen y título */}
                  <div className="flip-card-front">
                    <div className="project-image-container">
                      <img src={service.image || "/placeholder.svg"} alt={service.title} className="project-image" />
                    </div>
                    <h3 className="project-title">{service.title}</h3>
                  </div>

                  {/* Atrás - Descripción */}
                  <div className="flip-card-back">
                    <h3 className="project-title-back">{service.title}</h3>
                    <div className="project-description-container">
                      <p className="project-description">{service.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ServicesSection
